import React from 'react';
import classNames from 'classnames';

export default function ChevronUpIcon({ className = '' }) {
	return (
		<span
			className={classNames('icon icon-caret_down', className)}
			style={{ transform: 'rotate(0.5turn) translateY(25%)' }}
		/>
	);
}
